// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const WORKSHEET_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  WORKSHEET_BACKGROUND_COLOR: 'common.worksheet.background.color',
  WORKSHEET_POPUP_MARKER: 'common.worksheet.popup.marker',
  WORKSHEET_VIEW_BORDERS: 'common.worksheet.view.borders',
  WORKSHEET_VISIBLE: 'common.worksheet.visible',
  QUERY_EXECUTION_STRATEGY: 'common.query.execution',
  PERIODICAL_QUERY_EXECUTION_INTERVAL: 'common.query.execution.periodical.interval',
  SHOW_LOADING_INDICATORS_IN_LIVE_MODE: 'common.worksheet.live-mode.loading-indicators.show',
  ANALYSIS_CONTEXT_VISIBILITY: 'common.worksheet.analysis-context.visibility',
  LINEAR_LAYOUT_VIEW_ORDER: 'common.worksheet.linear-layout.view-order'
} as const;

/** @see net/disy/cadenza/workbook/model/WorksheetSettingsKey.java */
export type WorksheetSettingsKey = keyof typeof WORKSHEET_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const WorksheetSettingsKey = {
  values: Object.keys(WORKSHEET_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly WorksheetSettingsKey[],
  toPersistenceKey: (value: WorksheetSettingsKey) => WORKSHEET_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = WorksheetSettingsKey.values.find(key => WORKSHEET_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No WorksheetSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
